package com.milta.core.localization.translations.en

import com.milta.core.localization.CommonStrings

internal val Common = CommonStrings(
    appName = "Milta",
    ok = "OK",
    cancel = "Cancel",
    confirm = "Confirm",
    save = "Save",
    delete = "Delete",
    back = "Back",
    loading = "Loading…",
    retry = "Retry",
    language = "Language",
    welcomeTitle = "Welcome to Milta",
    welcomeSubtitle = "Your smart delivery assistant",
    alreadyHaveAccount = "I already have an account",
    createAccount = "Create an account",
    continueWithGoogle = "Continue with Google",
    continueWithApple = "Continue with Apple",
    oauthErrorGeneric = "Something went wrong while signing in. Please try again.",
    oauthAppleWebComingSoon = "Apple sign-in is coming soon on web.",
    oauthDriverAccountNotAllowedOnWeb = "Driver accounts can't access the web dashboard. Please sign in from the mobile app.",
    oauthAccountNotFoundOnWeb = "No Milta account was found for this Google account.",
    errorOffline = "No internet connection.",
    navTourneesDuJour = "Today's routes",
    navAjouterUneTournee = "Add a route",
    navHistoriqueDesPreuves = "Delivery history",
    navParametres = "Settings",
    sidebarRoleManagerLabel = "Manager",
    noDeliveriesYetTitle = "No deliveries yet",
    noDeliveriesYetSubtitle = "Tap \"Add deliveries\" to add some",
    optimizationUnavailableExplanation = "Would you like to create the route without optimizing, or try again?",
    createWithoutOptimizationAction = "Create without optimizing",
    gpsAppSheetTitle = "Choose a navigation app",
    addressSearchingLabel = "Searching…",
)
